module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/viability-report/viability-grid/viability-grid.component.css
// module id = ./src/app/landprocurement/viability-report/viability-grid/viability-grid.component.css
// module chunks = main